<template>
  <div>
    <el-dialog title="处理售后" :visible.sync="formVisible" :close-on-click-modal="false" width="1300px">
      <el-descriptions title="其他信息" :column="1" class="section-content mt10" style="margin-left: 20px">
        <el-descriptions-item label="附件">
          <div v-if="attachment">
            <div v-for="(item,index) in attachment && attachment.split(',')" :key="index" class="attachment-item">
              <!-- 图片文件 -->
              <el-image style="width: 100px; height: 100px;" v-if="isImageFile(item)" class="banner-box" :src="item" :preview-src-list="getImageList()">
              </el-image>
              <!-- 视频文件 -->
              <video v-else-if="isVideoFile(item)" class="video-box" controls :src="item">
              </video>
              <!-- 其他文件类型 -->
              <div v-else class="file-link">
                <a :href="item" target="_blank" class="file-download">
                  <i class="el-icon-document"></i>
                  {{ getFileName(item) }}
                </a>
              </div>
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="备注">{{remarks}}</el-descriptions-item>
      </el-descriptions>
      <el-form v-loading="fullscreenLoading" ref="dataForm" size="small" :rules="formRules" :model="form" label-position="right" label-width="110px">

        <el-form-item label="售后商品：" required class="width100">
          <div class="table-list mt20">
            <div class="spec-head">
              <div class="sp-col flex2">售后商品信息</div>
              <div class="sp-col">售后方式(必填)</div>
              <div class="sp-col">退款金额(必填)</div>
              <div class="sp-col">换货商品(必填)</div>
              <div class="sp-col">换货数量(必填)</div>
              <div class="sp-col">补差金额(选填)</div>
            </div>
            <div class="spec-item" v-for="(it, idx) in form.goodsList" :key="idx">
              <el-form-item class="sp-col flex2" style="width: 100%;">
                <div class="goods-info">
                  <div class="goods-header">
                    <img src="@/assets/gd.png" alt="" class="goods-icon" />
                    <!-- REQ-2026-234328 产品规格接在规格后面显示，取不到时不占位 -->
                    <span class="goods-name">{{ it.platformProductName }} - {{ it.spec || '无规格值' }}<template v-if="it.productSpec"> / {{ it.productSpec }}</template></span>
                  </div>
                  <div class="goods-details">
                    <div class="detail-row">
                      <span class="detail-label">验收数量:</span>
                      <span class="detail-value quantity">×{{ it.acceptanceQuantity }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">批次号:</span>
                      <span class="detail-value">{{ it.batchNumber }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">入库信息:</span>
                      <span class="detail-value">{{ it.inBoundQuantity }}</span>
                    </div>
                  </div>
                  <div class="goods-price">
                    <div class="detail-row">
                      <span class="detail-label">商品零售价:</span>
                      <span class="detail-value price">¥{{ it.retailPrice }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">有效期:</span>
                      <span class="detail-value">{{ it.expirationDate && it.expirationDate.substring(0,10) }}</span>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item class="sp-col" label-width="0" :prop="`goodsList[${idx}].afterMethod`" :rules="{required: true,message: '请选择售后方式',trigger: 'change',}">
                <el-select v-model="it.afterMethod" placeholder="请选择售后方式" clearable @change="handleAfterMethodChange(idx)">
                  <el-option label="退款" :value="1"></el-option>
                  <el-option label="换货" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="sp-col" label-width="0" :prop="`goodsList[${idx}].refundMoney`" :rules="getRefundMoneyRules(idx)">
                <el-input v-model="it.refundMoney" placeholder="请输入退款金额" :disabled="it.afterMethod === 2" @blur="handleRefundMoneyBlur(idx)" @input="handleRefundMoneyInput(idx)" />
              </el-form-item>
              <el-form-item class="sp-col" label-width="0" :prop="`goodsList[${idx}].exchangeGoodsId`" :rules="getExchangeGoodsRules(idx)">
                <el-select style="border:none" filterable v-model="it.exchangeGoodsId" placeholder="请选择换货商品" popper-class="popperClass" @change="getGoodsGG(it,idx)" clearable size="small" :disabled="it.afterMethod === 1">
                  <el-option v-for="item in sysGoods" :key="item.id" :label="item.name + (item.aliasName ? ' [' + item.aliasName + ']' : '')" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="sp-col" label-width="0" :prop="`goodsList[${idx}].exchangeGoodsCount`" :rules="getExchangeCountRules(idx)">
                <el-input v-model="it.exchangeGoodsCount" placeholder="请输入换货数量" :disabled="it.afterMethod === 1" @input="updateAddressValidation" />
              </el-form-item>
              <el-form-item class="sp-col" label-width="0" :prop="`goodsList[${idx}].repairMoney`">
                <el-input v-model="it.repairMoney" placeholder="请输入补差金额" />
              </el-form-item>
            </div>
          </div>
          <div class="summary-info">
            <div class="summary-item">
              <span class="summary-label">退款总金额:</span>
              <span class="summary-value refund">¥{{ totalRefundAmount }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">换货商品数量:</span>
              <span class="summary-value exchange">{{ totalExchangeCount }}件</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">补差金额:</span>
              <span class="summary-value difference">¥{{ totalRepairAmount }}</span>
            </div>
          </div>
        </el-form-item>
        <!-- 新增统计信息 -->

        <el-form-item label="邮费：" prop="expressCode">
          <div class="flexs">
            <el-select v-model="form.expressCode" placeholder="请选择快递方式" clearable>
              <el-option v-for="(it,idx) in deliveryAllList" :key="idx" :label="it.name" :value="it.id"></el-option>
            </el-select>
            <el-input v-model="form.freightFee" placeholder="请输入邮费" />
          </div>
        </el-form-item>
        <el-form-item label="收货地址：" prop="customerAddressId">
          <el-select v-model="form.customerAddressId" placeholder="请选择收货地址" clearable>
            <el-option v-for="(it,idx) in userAddrList" :key="idx" :label="it.allAddr" :value="it.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="补差支付方式：" prop="payType">
          <el-select v-model="form.payType" placeholder="请选择" clearable>
            <el-option label="现金支付" :value="0"></el-option>
            <el-option label="零售价" :value="3"></el-option>
          </el-select>
          <div class="hint">零售价支付，用户同意认可处理结果将直接充零售价账户扣除</div>
        </el-form-item>
        <el-form-item label="商品类型：" prop="isActivityAfter">
          <el-radio-group v-model="form.isActivityAfter">
            <el-radio :label="false">普通商品</el-radio>
            <el-radio :label="true">活动商品</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="doCreate()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import sysGoodsApi from '@/api/sys/sysGoods'
function initFormBean() {
  const formBean = {
    id: null,
    goodsList: [{ id: '', afterMethod: 1, refundMoney: '', exchangeGoodsId: '', exchangeCombineId: '', exchangeGoodsCount: '', repairMoney: '', platformProductId: '' }],
    customerAddressId: '',
    expressCode: '',
    freightFee: '',
    payType: '',
    isActivityAfter: null,
  }
  return formBean
}
export default {
  data() {
    return {
      formRules: {
        customerAddressId: [],
        payType: [{ required: true, message: '请选择补差支付方式', trigger: 'change' }],
        isActivityAfter: [{ required: true, message: '请选择商品类型', trigger: 'change' }],
      },
      form: initFormBean(),
      formVisible: false,
      selectItems: [],
      sysGoods: [],
      fullscreenLoading: false,
      orderSourceType: 0,    //1 是从待认领售后订单页面来的
      // userList: [],
      isRepSub: false,
      userAddrList: [],
      deliveryAllList: [],
      attachment: '',
      remarks: ''
    };
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
    this.getAllDeliveryList(1)
    this.getGoods()
  },
  watch: {

  },
  computed: {
    // 新增计算属性：判断是否有换货商品
    hasExchangeGoods() {
      return this.form.goodsList.some(item => item.afterMethod === 2);
    },
    // 计算退款总金额
    totalRefundAmount() {
      return this.form.goodsList
        .filter(item => item.afterMethod === 1 && item.refundMoney)
        .reduce((total, item) => {
          const amount = parseFloat(item.refundMoney || 0);
          return total + (isNaN(amount) ? 0 : amount);
        }, 0)
        .toFixed(2);
    },

    // 计算换货商品数量
    totalExchangeCount() {
      return this.form.goodsList
        .filter(item => item.afterMethod === 2 && item.exchangeGoodsCount)
        .reduce((total, item) => {
          const count = parseInt(item.exchangeGoodsCount || 0);
          return total + (isNaN(count) ? 0 : count);
        }, 0);
    },

    // 计算补差金额
    totalRepairAmount() {
      return this.form.goodsList
        .filter(item => item.repairMoney)
        .reduce((total, item) => {
          const amount = parseFloat(item.repairMoney || 0);
          return total + (isNaN(amount) ? 0 : amount);
        }, 0)
        .toFixed(2);
    }
  },
  methods: {
    // 判断是否为图片文件
    isImageFile(url) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      return imageExtensions.some(ext => url.toLowerCase().includes(ext));
    },
    // 判断是否为视频文件
    isVideoFile(url) {
      const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm'];
      return videoExtensions.some(ext => url.toLowerCase().includes(ext));
    },
    // 获取所有图片文件列表（用于图片预览）
    getImageList() {
      if (!this.attachment) return [];
      return this.attachment.split(',').filter(item => this.isImageFile(item));
    },
    // 获取文件名
    getFileName(url) {
      return url.split('/').pop();
    },
    // 新增方法：动态更新收货地址验证规则（当 totalExchangeCount > 0 才必填）
    updateAddressValidation() {
      const mustRequireAddress = this.totalExchangeCount > 0;
      const addressRules = mustRequireAddress
        ? [{ required: true, message: '请选择收货地址', trigger: 'change' }]
        : [];

      this.$set(this.formRules, 'customerAddressId', addressRules);

      // 清除收货地址的验证状态
      this.$nextTick(() => {
        if (this.$refs['dataForm']) {
          this.$refs['dataForm'].clearValidate('customerAddressId');
        }
      });
    },
    // 新增方法：处理售后方式变化
    handleAfterMethodChange(idx) {
      const item = this.form.goodsList[idx];
      if (item.afterMethod === 1) {
        // 退款模式：清空换货相关字段，设置默认退款金额
        item.exchangeGoodsId = '';
        item.exchangeCombineId = '';
        item.exchangeGoodsCount = '';
        item.huanSpeList = [];
        // 计算默认退款金额
        item.refundMoney = (item.retailPrice * item.acceptanceQuantity).toFixed(2);
      } else if (item.afterMethod === 2) {
        // 换货模式：清空退款金额
        item.refundMoney = '';
      }
      // 更新收货地址验证规则
      this.updateAddressValidation();
      // 清除验证
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    // 新增方法：处理退款金额输入
    handleRefundMoneyInput(idx) {
      const item = this.form.goodsList[idx];
      if (item.refundMoney && item.afterMethod === 1) {
        // 只允许输入数字和小数点
        const value = item.refundMoney.toString().replace(/[^\d.]/g, '');
        // 确保只有一个小数点
        const parts = value.split('.');
        if (parts.length > 2) {
          item.refundMoney = parts[0] + '.' + parts.slice(1).join('');
        } else {
          item.refundMoney = value;
        }
        // 限制小数点后两位
        if (parts.length === 2 && parts[1].length > 2) {
          item.refundMoney = parts[0] + '.' + parts[1].substring(0, 2);
        }
      }
    },

    // 修改退款金额失焦事件
    handleRefundMoneyBlur(idx) {
      const item = this.form.goodsList[idx];
      if (item.afterMethod === 1 && item.refundMoney) {
        // 验证是否为有效数字
        const amount = parseFloat(item.refundMoney);
        if (isNaN(amount) || amount < 0) {
          item.refundMoney = '';
          this.$message.warning('请输入有效的退款金额');
          return;
        }

        // 验证退款金额不能超过商品总价
        const maxRefund = item.retailPrice * item.acceptanceQuantity;
        if (amount > maxRefund) {
          this.$message.warning(`退款金额不能超过商品总价 ¥${maxRefund.toFixed(2)}`);
          item.refundMoney = maxRefund.toFixed(2);
        } else {
          // 格式化金额，保留两位小数
          item.refundMoney = amount.toFixed(2);
        }
      }
    },
    // 新增方法：获取退款金额验证规则
    getRefundMoneyRules(idx) {
      const item = this.form.goodsList[idx];
      if (item.afterMethod === 1) {
        return [{ required: true, message: '请输入退款金额', trigger: 'blur' }];
      }
      return [];
    },

    // 新增方法：获取换货商品验证规则
    getExchangeGoodsRules(idx) {

      const item = this.form.goodsList[idx];
      if (item.afterMethod === 2) {
        return [{ required: true, message: '请选择换货商品', trigger: 'change' }];
      }
      return [];
    },

    // 新增方法：获取换货数量验证规则
    getExchangeCountRules(idx) {
      const item = this.form.goodsList[idx];
      if (item.afterMethod === 2) {
        return [{ required: true, message: '请输入换货数量', trigger: 'blur' }];
      }
      return [];
    },

    getAllDeliveryList(ty) {
      goodsOrderApi.getDeliveryList({ isEnable: true, orderType: ty }).then(res => {
        let { list } = res.data;
        this.deliveryAllList = list;
      })
    },
    getAddress(userId) {
      goodsOrderApi.getUserAddrList({ userId }).then((res) => {
        let { list } = res.data;
        if (list.length) {
          list.forEach((it) => {
            it.allAddr = it.country + it.province + it.city + it.district + it.detailedAddress;
          });
        }
        this.form.customerAddressId = ''
        this.userAddrList = list;
      });
    },
    resetForm() {
      this.form = initFormBean()
    },
    handleAddOrder(row, type) {
      if (type) this.orderSourceType = type;
      this.getDetails(row.id);

    },
    getDetails(id) {
      this.resetForm()
      this.form.id = id;
      goodsOrderApi.getAfterDetail(id).then(({ data }) => {
        this.attachment = data.attachment
        this.remarks = data.remarks
        let arr = [];
        let list = data.goodsList
        list = list.filter(it => it.isSign === true)
        list.forEach(it => {
          let find = data.exchangeGoodsList.find(itt => itt.afterGoodsId === it.id)
          arr.push({
            acceptanceQuantity: it.acceptanceQuantity,
            batchNumber: it.batchNumber,
            inBoundQuantity: it.inBoundQuantity,
            expirationDate: it.expirationDate,
            afterGoodsName: it.afterGoodsName,
            platformProductName: it.platformProductName,
            platformCombineSpecName: it.platformCombineSpecName,
            spec: it.spec,
            // REQ-2026-234328 产品规格：模板第 44 行要显示它，这里漏了就永远是空。
            // 这个 arr.push 是手工列字段的白名单，接口新增字段必须同步加一行，否则「后端给了、前端没接」。
            productSpec: it.productSpec,
            retailPrice: it.retailPrice,
            id: it.id,
            afterMethod: it.afterMethod,
            exchangeCombineId: find ? find.combineId : '',
            exchangeGoodsCount: find ? find.goodsCount : '',
            exchangeGoodsId: find ? find.goodsId : '',
            exchangeGoodsName: find ? find.goodsName : '',
            platformProductId: it.platformProductId,
            refundMoney: it.refundMoney,
            repairMoney: it.repairMoney,
            huanSpeList: find ? this.sysGoods.find(item => item.id === find.goodsId).specValueList : []
          });
        })
        this.$set(this.form, 'goodsList', arr)
        this.formVisible = true;
        // 初始化一次地址校验规则（基于换货数量）
        this.updateAddressValidation();
        // if (data.customerId) {
        //   this.userList = [{ id: data.customerId, name: data.applyInfo && data.applyInfo.name, pho: data.applyInfo && data.applyInfo.pho }]
        //   this.form.customerId = data.customerId
        // } else {
        //   this.userList = []
        //   this.form.customerId = ''
        // }
        this.getAddress(data.userId)
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    getGoods() {
      sysGoodsApi.getGoodRecomList().then(({ data }) => {
        this.sysGoods = data
      })
    },
    getGoodsGG(it, idx) {
      this.sysGoods.forEach(item => {
        if (it.exchangeGoodsId == item.id) {
          it.huanSpeList = item.specValueList
          // 商品只有一个规格，自动选中
          if (item.specValueList && item.specValueList.length === 1) {
            it.exchangeCombineId = item.specValueList[0].id
          } else if (item.specValueList && item.specValueList.length > 0) {
            it.exchangeCombineId = item.specValueList[0].id
          } else {
            it.exchangeCombineId = ''
          }
        }
      })
    },
    closeDialog() {
      this.fullscreenLoading = false;
      this.formVisible = false;
    },
    // 新增方法：根据商品ID获取商品名称
    getGoodsName(goodsId) {
      const goods = this.sysGoods.find(item => item.id === goodsId);
      return goods ? goods.name : '';
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form))
          if (this.fullscreenLoading) return;
          params.freightFee = params.freightFee || 0
          // 根据接口字段调整数据结构
          params.goodsList = params.goodsList.map(item => {

            const newItem = {
              id: item.id,
              afterMethod: item.afterMethod,
              refundMoney: item.afterMethod === 1 ? item.refundMoney : null,
              exchangeGoodsId: item.afterMethod === 2 ? item.exchangeGoodsId : null,
              exchangeGoodsName: item.afterMethod === 2 ? this.getGoodsName(item.exchangeGoodsId) : null,
              exchangeCombineId: item.afterMethod === 2 ? item.exchangeCombineId : null,
              exchangeGoodsCount: item.afterMethod === 2 ? item.exchangeGoodsCount : null,
              repairMoney: item.repairMoney || 0,
              platformProductId: item.platformProductId
            };
            return newItem;
          });
          if (this.isRepSub) return
          this.isRepSub = true
          this.fullscreenLoading = true;
          goodsOrderApi.afterSolution(params).then((data) => {
            this.fullscreenLoading = false;
            this.isRepSub = false
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(data) {
      if (data.code === '0') {
        this.$message.success('操作成功')
        this.formVisible = false;
        this.$emit('created')
      } else {
        this.$message.error(data.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.reimbursement {
  padding: 0 50px;
}
.dialog-footer {
  // display: flex;
  // justify-content: center;
  // padding: 20px 0;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  // padding: 10px 0;
}
.reimbursement {
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}

.popperClass {
  border-color: #fff !important;
}
.spec-item {
  .el-select .el-input {
    box-shadow: none !important;
    border: none !important;
  }
}
.goods-info {
  width: 100%;
  padding: 5px;
  text-align: left;
  font-size: 12px;

  .goods-header {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    line-height: 24px;
    padding-left: 5px;
    .goods-icon {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }

    .goods-name {
      font-size: 12px;
      color: #333;
      font-weight: normal;
    }
  }

  .detail-row {
    display: flex;
    align-items: center;
    line-height: 1.2;

    .detail-label {
      font-size: 11px;
      color: #666;
    }

    .detail-value {
      font-size: 11px;
      color: #333;

      &.quantity {
        color: #333;
        font-weight: normal;
      }

      &.price {
        color: #ff4949;
        font-weight: normal;
      }
    }
  }
}

.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    height: auto; // 改为自适应高度
    margin-bottom: 0;
    display: inline-flex;
    align-items: center; // 改为顶部对齐
    justify-content: center; // 改为左对齐
    border-right: 1px solid #e4e4e4;
    padding: 3px; // 添加内边距

    &.flex05 {
      flex: 0.5;
    }
    &.flex2 {
      flex: 2;
      padding-right: 0; // 去掉售后商品信息列的右边距
      justify-content: flex-start;
    }

    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;
    height: 40px; // 固定表头高度

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: stretch; // 改为拉伸对齐
    border-top: 1px solid #e4e4e4;
    min-height: 100px; // 增加最小高度

    .sp-col {
      .el-input {
        .el-input__inner {
          border: none !important;
          text-align: center;
        }
      }
      .el-select {
        .el-input__inner {
          text-align: center; // 下拉框文字居中
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}

.goods-info {
  width: 100%;
  padding: 0;
  text-align: left;
  font-size: 12px;

  .goods-header {
    display: flex;
    align-items: center;

    .goods-icon {
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }

    .goods-name {
      font-size: 13px;
      color: #333;
      font-weight: 500;
    }
  }

  .goods-details {
    display: flex;
    gap: 2px; // 添加间距
    display: inline-block;
  }

  .goods-price {
    display: flex;
    gap: 2px; // 添加间距
    display: inline-block;
    vertical-align: top;
  }

  .detail-row {
    display: flex;
    align-items: center;
    line-height: 1.3;
    padding: 1px 8px; // 添加内边距
    border-radius: 4px; // 添加圆角
    background-color: #fff; // 背景色

    .detail-label {
      font-size: 12px;
      color: #666;
    }

    .detail-value {
      font-size: 12px;
      color: #333;

      &.quantity {
        color: #333;
        font-weight: normal;
      }

      &.price {
        color: #ff4949;
        font-weight: 500;
      }
    }
  }
}
.summary-info {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 20px;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e4e4e4;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.summary-label {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.summary-value {
  font-size: 16px;
  font-weight: 600;

  &.refund {
    color: #ff4949;
  }

  &.exchange {
    color: #ff4949;
  }

  &.difference {
    color: #ff4949;
  }
}
.attachment-item {
  display: inline-block;
  margin: 2px;
  vertical-align: top;
  video{
    width: 200px;
    height: 150px;
    border-radius: 4px;
    object-fit: cover;
  }
}
</style>